export default __webpack_public_path__ + "static/1d3191cd-ae8c-45e2-bb04-11e96d8fa974-1cae080777db95b3bb069cecf10a9f02.woff2";